/** License validity of the memory stick. */
export enum MemoryStickLicenseState { 
	/** No stick is connected at all. */
	None = "None", 
	/** A memory stick is present, but it contains no valid license file. */
	NotLicensed = "NotLicensed", 
	/**
	* A memory stick is present with a valid license file, but
	*             the license does not include this specific device.
	*/
	NotLicensedForThisDevice = "NotLicensedForThisDevice", 
	/** A memory stick with a valid license for this device is present. */
	Licensed = "Licensed"
}
